import React from "react";
import Avatar from "../inputs/Avatar";
import {
  useLikeCommentMutation,
  useUnlikeCommentMutation,
} from "../../services/users/community";
import { arabicMonthes, displayDate } from "../../utils/arabicDatesUtilities";
import { useNavigate } from "react-router-dom";

const CommentUserCard = ({
  comment,
  readOnlyInteractions,
  profileBasePath = "/employee/profile",
  onToggleCommentLike,
}) => {
  const [like] = useLikeCommentMutation();
  const [unlike] = useUnlikeCommentMutation();

  let navigate = useNavigate();

  const isOrgAdminAuthor =
    comment.author?.author_type === "OrganizationAdmin";

  const navigateToUserprofile = () => {
    if (isOrgAdminAuthor) return;
    navigate(`${profileBasePath}/${comment.author.id}`);
  };

  let createdAt = new Date(comment?.created_at);
  const arabicMonth = arabicMonthes[createdAt.getMonth()];
  return (
    <div className="comment-user">
      <Avatar width="40" height="40" avatarUrl={comment?.author?.avatar_url} />
      <div className="ms-2 comment-user__body">
        <div className="comment-user__header d-flex align-items-center">
          <div className="comment-user__author">
            <p
              role={isOrgAdminAuthor ? undefined : "button"}
              onClick={isOrgAdminAuthor ? undefined : navigateToUserprofile}
              className="mb-0 font_16 font-extrabold text-truncate"
              style={isOrgAdminAuthor ? { cursor: "default" } : undefined}
            >
              {comment?.author?.name}
            </p>
            <p className="mb-0 font_14 font-color-grey-light text-truncate">
              {displayDate(comment?.created_at)}
            </p>
          </div>
          <div className="comment-user__likes d-flex align-items-center">
            <span className="me-2 font_16 font-extrabold">
              {comment?.likes_count}
            </span>
            {readOnlyInteractions ? (
              <span
                className={`${
                  comment?.is_liked_by_me
                    ? "fas font-color-red"
                    : "far font-color-grey"
                } font_20 fa-heart fa-fw me-2 post-like-icon--readonly`}
                aria-hidden
              />
            ) : (
              <button
                type="button"
                className={`${
                  comment?.is_liked_by_me
                    ? "fas font-color-red"
                    : "far font-color-grey"
                } font_20 fa-heart fa-fw me-2 border-0 bg-transparent p-0`}
                onClick={() =>
                  onToggleCommentLike
                    ? onToggleCommentLike(comment)
                    : comment?.is_liked_by_me
                      ? unlike(comment?.id)
                      : like(comment?.id)
                }
              />
            )}
          </div>
        </div>
        <p className="mb-0 font_16 mt-2 text-break">{comment?.body}</p>
      </div>
    </div>
  );
};

export default CommentUserCard;
